import { PLAYER_COLORS } from 'shared';

export const playerColor = (index: number): string =>
  PLAYER_COLORS[index % PLAYER_COLORS.length]!;

/** Ja is teal and Nein is red, matching the printed ballot cards. */
export const choiceColor = (choice: 'JA' | 'NEIN'): string =>
  choice === 'JA' ? 'var(--color-teal)' : 'var(--color-red)';

export const cx = (...parts: Array<string | false | null | undefined>): string =>
  parts.filter(Boolean).join(' ');

/** Deterministic per-key tilt, so printed things sit off-square but never jitter. */
export function tiltFor(key: string): string {
  let hash = 0;
  for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) | 0;
  return ['tilt-a', 'tilt-b', 'tilt-c'][Math.abs(hash) % 3]!;
}
